import { styled } from '@mui/material/styles';
import { Box, Typography, Button, TableCell, TableRow } from '@mui/material';

// ============================================
// Header & Notice
// ============================================
export const HeaderRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

export const Notice = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#737373',
});

export const RegisterButton = styled(Button)({
  height: '40px',
  minWidth: '120px',
  backgroundColor: '#4ab3bc',
  borderRadius: '8px',
  fontSize: '16px',
  fontWeight: 600,
  color: '#fff',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#3da3ab',
  },
});

// ============================================
// Table
// ============================================
export const HeaderCell = styled(TableCell)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#262626',
  textAlign: 'center',
  padding: '12px',
  backgroundColor: '#f2f2f2',
  borderBottom: '1px solid #d9d9d9',
  whiteSpace: 'nowrap',
});

export const BodyCell = styled(TableCell)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#262626',
  textAlign: 'center',
  padding: '12px',
  borderBottom: '1px solid #d9d9d9',
  whiteSpace: 'nowrap',
});

export const DataRow = styled(TableRow)({
  backgroundColor: '#fff',
  height: '56px',
});

// ============================================
// Status & Buttons
// ============================================
const STATUS_COLORS = {
  VERIFIED: '#55c982',
  UNDER_REVIEW: '#f0a020',
  UNVERIFIED: '#f0a020',
};

export const StatusText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'status',
})(({ status }) => ({
  fontSize: '14px',
  fontWeight: 600,
  color: STATUS_COLORS[status] || '#737373',
}));

export const ActionGroup = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
});

export const VerifyButton = styled(Button)({
  height: '32px',
  padding: '4px 16px',
  fontSize: '14px',
  fontWeight: 600,
  color: '#4ab3bc',
  backgroundColor: '#fff',
  border: '1px solid #4ab3bc',
  borderRadius: '4px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#f0fafb',
  },
});

export const DeleteButton = styled(Button)({
  height: '32px',
  padding: '4px 16px',
  fontSize: '14px',
  fontWeight: 600,
  color: '#737373',
  backgroundColor: '#fff',
  border: '1px solid #d9d9d9',
  borderRadius: '4px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
});
